module.exports = __webpack_public_path__ + "img/iBowKINTAI-Horizontal-green.1399b1c5.svg";